<template>

  <div class="tastes" v-if="taste?.length">

    <div class="divider">      
      {{ $t('harvest_view_tastes_like') }}
    </div>

    
    <div class="lst">
         
      <div 
        v-for="(opt, opt_key) in taste"
        :key="opt_key"
        class="taste">
        <img loading="lazy" class="img" :src="ReviewTasteEnumInfo[opt.id]['img']">
        <div class="nm">
          {{ opt.name }}
        </div>
      </div> 
         

    </div>


 
 
  </div>

  
</template>

<script setup lang="ts">
 
import { ReviewTasteEnumInfo } from '@/types/diary';

const props = defineProps({
  taste: {
    type: Array,
    default: null,
  },
})
 

</script>

<style scoped>
 
.lst{
  display: flex;
  justify-content: center;
}
.taste{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 1rem;
}
  
 
.taste .img{
  width: 90px;
  height: 90px;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
}

.taste .nm{
  margin-top: 10px;
}
  
/* .berries{ background-image: url(/images/tastes/berries.svg); } 
.berry{ background-image: url(/images/tastes/berry.svg); } 
.caramel{ background-image: url(/images/tastes/caramel.svg); } 
.cheese{ background-image: url(/images/tastes/cheese.svg); } 
.chocolate{ background-image: url(/images/tastes/chocolate.svg); } 
.citrus{ background-image: url(/images/tastes/citrus.svg); } 
.cream{ background-image: url(/images/tastes/cream.svg); } 
.diesel{ background-image: url(/images/tastes/diesel.svg); } 
.earthy{ background-image: url(/images/tastes/earthy.svg); } 
.flowery{ background-image: url(/images/tastes/flowery.svg); } 
.fruity{ background-image: url(/images/tastes/fruity.svg); } 
.herbs{ background-image: url(/images/tastes/herbs.svg); } 
.mint{ background-image: url(/images/tastes/mint.svg); } 
.nutty{ background-image: url(/images/tastes/nutty.svg); } 
.pine{ background-image: url(/images/tastes/pine.svg); } 
.pungent{ background-image: url(/images/tastes/pungent.svg); } 
.sour{ background-image: url(/images/tastes/sour.svg); } 
.sweet{ background-image: url(/images/tastes/sweet.svg); } 
.tropical{ background-image: url(/images/tastes/tropical.svg); } 
.woody{ background-image: url(/images/tastes/woody.svg); }  */


</style>
